{
  "ember": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.13333333333333333,
          0.15294117647058825,
          0.16862745098039217
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.10980392156862745,
          0.16470588235294117,
          0.23137254901960785
        ],
        "alpha": 1,
        "hex": "#1c2a3b"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.10980392156862745,
          0.16470588235294117,
          0.2980392156862745
        ],
        "alpha": 1,
        "hex": "#1c2a4c"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1450980392156863,
          0.14901960784313725,
          0.3607843137254902
        ],
        "alpha": 1,
        "hex": "#25265c"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2,
          0.12156862745098039,
          0.40784313725490196
        ],
        "alpha": 1,
        "hex": "#331f68"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.26666666666666666,
          0.06666666666666667,
          0.4392156862745098
        ],
        "alpha": 1,
        "hex": "#441170"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3803921568627451,
          0.06666666666666667,
          0.4588235294117647
        ],
        "alpha": 1,
        "hex": "#611175"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5019607843137255,
          0.058823529411764705,
          0.45098039215686275
        ],
        "alpha": 1,
        "hex": "#800f73"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6235294117647059,
          0.03529411764705882,
          0.41568627450980394
        ],
        "alpha": 1,
        "hex": "#9f096a"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7372549019607844,
          0.027450980392156862,
          0.34509803921568627
        ],
        "alpha": 1,
        "hex": "#bc0758"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8431372549019608,
          0.08235294117647059,
          0.22745098039215686
        ],
        "alpha": 1,
        "hex": "#d7153a"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8705882352941177,
          0.16862745098039217,
          0.20392156862745098
        ],
        "alpha": 1,
        "hex": "#de2b34"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8941176470588236,
          0.23137254901960785,
          0.1803921568627451
        ],
        "alpha": 1,
        "hex": "#e43b2e"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9137254901960784,
          0.28627450980392155,
          0.15294117647058825
        ],
        "alpha": 1,
        "hex": "#e94927"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9333333333333333,
          0.33725490196078434,
          0.12941176470588237
        ],
        "alpha": 1,
        "hex": "#ee5621"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9529411764705882,
          0.38823529411764707,
          0.10588235294117647
        ],
        "alpha": 1,
        "hex": "#f3631b"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9686274509803922,
          0.45098039215686275,
          0
        ],
        "alpha": 1,
        "hex": "#f77300"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9764705882352941,
          0.5098039215686274,
          0
        ],
        "alpha": 1,
        "hex": "#f98200"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.5686274509803921,
          0
        ],
        "alpha": 1,
        "hex": "#fb9100"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.6274509803921569,
          0
        ],
        "alpha": 1,
        "hex": "#fba000"
      }
    },
    "1050": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.6862745098039216,
          0.0196078431372549
        ],
        "alpha": 1,
        "hex": "#faaf05"
      }
    }
  },
  "earthfire": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3215686274509804,
          0.21568627450980393,
          0.09803921568627451
        ],
        "alpha": 1,
        "hex": "#523719"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.37254901960784315,
          0.21176470588235294,
          0.050980392156862744
        ],
        "alpha": 1,
        "hex": "#5f360d"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4235294117647059,
          0.2,
          0
        ],
        "alpha": 1,
        "hex": "#6c3300"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.47843137254901963,
          0.1803921568627451,
          0
        ],
        "alpha": 1,
        "hex": "#7a2e00"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5294117647058824,
          0.14901960784313725,
          0
        ],
        "alpha": 1,
        "hex": "#872600"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5803921568627451,
          0.10588235294117647,
          0
        ],
        "alpha": 1,
        "hex": "#941b00"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6549019607843137,
          0.16470588235294117,
          0.0196078431372549
        ],
        "alpha": 1,
        "hex": "#a72a05"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7254901960784313,
          0.2196078431372549,
          0.043137254901960784
        ],
        "alpha": 1,
        "hex": "#b9380b"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8,
          0.27450980392156865,
          0.06666666666666667
        ],
        "alpha": 1,
        "hex": "#cc4611"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8784313725490196,
          0.3333333333333333,
          0.08627450980392157
        ],
        "alpha": 1,
        "hex": "#e05516"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9529411764705882,
          0.38823529411764707,
          0.10588235294117647
        ],
        "alpha": 1,
        "hex": "#f3631b"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9686274509803922,
          0.45098039215686275,
          0
        ],
        "alpha": 1,
        "hex": "#f77300"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9764705882352941,
          0.5098039215686274,
          0
        ],
        "alpha": 1,
        "hex": "#f98200"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.5686274509803921,
          0
        ],
        "alpha": 1,
        "hex": "#fb9100"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.6274509803921569,
          0
        ],
        "alpha": 1,
        "hex": "#fba000"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.6862745098039216,
          0.0196078431372549
        ],
        "alpha": 1,
        "hex": "#faaf05"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.7333333333333333,
          0.23137254901960785
        ],
        "alpha": 1,
        "hex": "#fabb3b"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.7803921568627451,
          0.3411764705882353
        ],
        "alpha": 1,
        "hex": "#fac757"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.8235294117647058,
          0.43529411764705883
        ],
        "alpha": 1,
        "hex": "#fbd26f"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9882352941176471,
          0.8666666666666667,
          0.5215686274509804
        ],
        "alpha": 1,
        "hex": "#fcdd85"
      }
    },
    "1050": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9921568627450981,
          0.9058823529411765,
          0.6039215686274509
        ],
        "alpha": 1,
        "hex": "#fde79a"
      }
    }
  },
  "fuchsia-heat": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.396078431372549,
          0,
          0.30196078431372547
        ],
        "alpha": 1,
        "hex": "#65004d"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4823529411764706,
          0.00784313725490196,
          0.37254901960784315
        ],
        "alpha": 1,
        "hex": "#7b025f"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5725490196078431,
          0.01568627450980392,
          0.4470588235294118
        ],
        "alpha": 1,
        "hex": "#920472"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6627450980392157,
          0.03137254901960784,
          0.5215686274509804
        ],
        "alpha": 1,
        "hex": "#a90885"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7568627450980392,
          0.050980392156862744,
          0.6
        ],
        "alpha": 1,
        "hex": "#c10d99"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8509803921568627,
          0.07058823529411765,
          0.6823529411764706
        ],
        "alpha": 1,
        "hex": "#d912ae"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9019607843137255,
          0.11764705882352941,
          0.5725490196078431
        ],
        "alpha": 1,
        "hex": "#e61e92"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9411764705882353,
          0.17647058823529413,
          0.4666666666666667
        ],
        "alpha": 1,
        "hex": "#f02d77"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9607843137254902,
          0.24313725490196078,
          0.3568627450980392
        ],
        "alpha": 1,
        "hex": "#f53e5b"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9647058823529412,
          0.3137254901960784,
          0.24313725490196078
        ],
        "alpha": 1,
        "hex": "#f6503e"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9529411764705882,
          0.38823529411764707,
          0.10588235294117647
        ],
        "alpha": 1,
        "hex": "#f3631b"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9686274509803922,
          0.45098039215686275,
          0
        ],
        "alpha": 1,
        "hex": "#f77300"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9764705882352941,
          0.5098039215686274,
          0
        ],
        "alpha": 1,
        "hex": "#f98200"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.5686274509803921,
          0
        ],
        "alpha": 1,
        "hex": "#fb9100"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.6274509803921569,
          0
        ],
        "alpha": 1,
        "hex": "#fba000"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.6862745098039216,
          0.0196078431372549
        ],
        "alpha": 1,
        "hex": "#faaf05"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.7333333333333333,
          0.23137254901960785
        ],
        "alpha": 1,
        "hex": "#fabb3b"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.7803921568627451,
          0.3411764705882353
        ],
        "alpha": 1,
        "hex": "#fac757"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.984313725490196,
          0.8235294117647058,
          0.43529411764705883
        ],
        "alpha": 1,
        "hex": "#fbd26f"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9882352941176471,
          0.8666666666666667,
          0.5215686274509804
        ],
        "alpha": 1,
        "hex": "#fcdd85"
      }
    },
    "1050": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9921568627450981,
          0.9058823529411765,
          0.6039215686274509
        ],
        "alpha": 1,
        "hex": "#fde79a"
      }
    }
  },
  "polar-glow": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.14901960784313725,
          0.39215686274509803
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.00392156862745098,
          0.2,
          0.5019607843137255
        ],
        "alpha": 1,
        "hex": "#013380"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.011764705882352941,
          0.2549019607843137,
          0.6196078431372549
        ],
        "alpha": 1,
        "hex": "#03419e"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.027450980392156862,
          0.30980392156862746,
          0.7411764705882353
        ],
        "alpha": 1,
        "hex": "#074fbd"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.050980392156862744,
          0.36470588235294116,
          0.8627450980392157
        ],
        "alpha": 1,
        "hex": "#0d5ddc"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0784313725490196,
          0.4235294117647059,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.4666666666666667,
          0.9058823529411765
        ],
        "alpha": 1,
        "hex": "#0077e7"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.49411764705882355,
          0.8156862745098039
        ],
        "alpha": 1,
        "hex": "#007ed0"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5098039215686274,
          0.7215686274509804
        ],
        "alpha": 1,
        "hex": "#0082b8"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5098039215686274,
          0.6352941176470588
        ],
        "alpha": 1,
        "hex": "#0082a2"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1803921568627451,
          0.5019607843137255,
          0.5568627450980392
        ],
        "alpha": 1,
        "hex": "#2e808e"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.25882352941176473,
          0.5725490196078431,
          0.6235294117647059
        ],
        "alpha": 1,
        "hex": "#42929f"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.32941176470588235,
          0.6392156862745098,
          0.6901960784313725
        ],
        "alpha": 1,
        "hex": "#54a3b0"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.403921568627451,
          0.7137254901960784,
          0.7568627450980392
        ],
        "alpha": 1,
        "hex": "#67b6c1"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4745098039215686,
          0.7843137254901961,
          0.8274509803921568
        ],
        "alpha": 1,
        "hex": "#79c8d3"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5490196078431373,
          0.8588235294117647,
          0.8980392156862745
        ],
        "alpha": 1,
        "hex": "#8cdbe5"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6039215686274509,
          0.8745098039215686,
          0.8980392156862745
        ],
        "alpha": 1,
        "hex": "#9adfe5"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6627450980392157,
          0.8901960784313725,
          0.8980392156862745
        ],
        "alpha": 1,
        "hex": "#a9e3e5"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7137254901960784,
          0.9058823529411765,
          0.9019607843137255
        ],
        "alpha": 1,
        "hex": "#b6e7e6"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7686274509803922,
          0.9215686274509803,
          0.9058823529411765
        ],
        "alpha": 1,
        "hex": "#c4ebe7"
      }
    },
    "1050": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8196078431372549,
          0.9333333333333333,
          0.9176470588235294
        ],
        "alpha": 1,
        "hex": "#d1eeea"
      }
    }
  },
  "glacier-pool": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.26666666666666666,
          0.06666666666666667,
          0.4392156862745098
        ],
        "alpha": 1,
        "hex": "#441170"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3176470588235294,
          0.11764705882352941,
          0.5333333333333333
        ],
        "alpha": 1,
        "hex": "#511e88"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.36470588235294116,
          0.16862745098039217,
          0.6313725490196078
        ],
        "alpha": 1,
        "hex": "#5d2ba1"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.41568627450980394,
          0.2235294117647059,
          0.7333333333333333
        ],
        "alpha": 1,
        "hex": "#6a39bb"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4588235294117647,
          0.27450980392156865,
          0.8392156862745098
        ],
        "alpha": 1,
        "hex": "#7546d6"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5019607843137255,
          0.3333333333333333,
          0.9450980392156862
        ],
        "alpha": 1,
        "hex": "#8055f1"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.45098039215686275,
          0.34901960784313724,
          0.9647058823529412
        ],
        "alpha": 1,
        "hex": "#7359f6"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.39215686274509803,
          0.3686274509803922,
          0.9803921568627451
        ],
        "alpha": 1,
        "hex": "#645efa"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3254901960784314,
          0.3843137254901961,
          0.9882352941176471
        ],
        "alpha": 1,
        "hex": "#5362fc"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.23529411764705882,
          0.403921568627451,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#3c67fd"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0784313725490196,
          0.4235294117647059,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5372549019607843,
          1
        ],
        "alpha": 1,
        "hex": "#0089ff"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.047058823529411764,
          0.6352941176470588,
          1
        ],
        "alpha": 1,
        "hex": "#0ca2ff"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.23137254901960785,
          0.7254901960784313,
          1
        ],
        "alpha": 1,
        "hex": "#3bb9ff"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.39215686274509803,
          0.803921568627451,
          1
        ],
        "alpha": 1,
        "hex": "#64cdff"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5490196078431373,
          0.8784313725490196,
          1
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6039215686274509,
          0.8901960784313725,
          1
        ],
        "alpha": 1,
        "hex": "#9ae3ff"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6549019607843137,
          0.8980392156862745,
          1
        ],
        "alpha": 1,
        "hex": "#a7e5ff"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7019607843137254,
          0.9098039215686274,
          0.996078431372549
        ],
        "alpha": 1,
        "hex": "#b3e8fe"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7490196078431373,
          0.9176470588235294,
          0.996078431372549
        ],
        "alpha": 1,
        "hex": "#bfeafe"
      }
    },
    "1050": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.796078431372549,
          0.9294117647058824,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#cbedfd"
      }
    }
  },
  "deep-current": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.043137254901960784,
          0.24705882352941178,
          0.2784313725490196
        ],
        "alpha": 1,
        "hex": "#0b3f47"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.07058823529411765,
          0.29411764705882354,
          0.32941176470588235
        ],
        "alpha": 1,
        "hex": "#124b54"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.09803921568627451,
          0.34509803921568627,
          0.3843137254901961
        ],
        "alpha": 1,
        "hex": "#195862"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.12549019607843137,
          0.396078431372549,
          0.44313725490196076
        ],
        "alpha": 1,
        "hex": "#206571"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.15294117647058825,
          0.4470588235294118,
          0.4980392156862745
        ],
        "alpha": 1,
        "hex": "#27727f"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1803921568627451,
          0.5019607843137255,
          0.5568627450980392
        ],
        "alpha": 1,
        "hex": "#2e808e"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5098039215686274,
          0.6352941176470588
        ],
        "alpha": 1,
        "hex": "#0082a2"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5098039215686274,
          0.7215686274509804
        ],
        "alpha": 1,
        "hex": "#0082b8"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.49411764705882355,
          0.8156862745098039
        ],
        "alpha": 1,
        "hex": "#007ed0"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.4666666666666667,
          0.9058823529411765
        ],
        "alpha": 1,
        "hex": "#0077e7"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0784313725490196,
          0.4235294117647059,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.5372549019607843,
          1
        ],
        "alpha": 1,
        "hex": "#0089ff"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.047058823529411764,
          0.6352941176470588,
          1
        ],
        "alpha": 1,
        "hex": "#0ca2ff"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.23137254901960785,
          0.7254901960784313,
          1
        ],
        "alpha": 1,
        "hex": "#3bb9ff"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.39215686274509803,
          0.803921568627451,
          1
        ],
        "alpha": 1,
        "hex": "#64cdff"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5490196078431373,
          0.8784313725490196,
          1
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6039215686274509,
          0.8901960784313725,
          1
        ],
        "alpha": 1,
        "hex": "#9ae3ff"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6549019607843137,
          0.8980392156862745,
          1
        ],
        "alpha": 1,
        "hex": "#a7e5ff"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7019607843137254,
          0.9098039215686274,
          0.996078431372549
        ],
        "alpha": 1,
        "hex": "#b3e8fe"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7490196078431373,
          0.9176470588235294,
          0.996078431372549
        ],
        "alpha": 1,
        "hex": "#bfeafe"
      }
    },
    "1050": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.796078431372549,
          0.9294117647058824,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#cbedfd"
      }
    }
  },
  "blue-red": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.14901960784313725,
          0.39215686274509803
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.00392156862745098,
          0.2,
          0.5019607843137255
        ],
        "alpha": 1,
        "hex": "#013380"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.011764705882352941,
          0.2549019607843137,
          0.6196078431372549
        ],
        "alpha": 1,
        "hex": "#03419e"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.027450980392156862,
          0.30980392156862746,
          0.7411764705882353
        ],
        "alpha": 1,
        "hex": "#074fbd"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.050980392156862744,
          0.36470588235294116,
          0.8627450980392157
        ],
        "alpha": 1,
        "hex": "#0d5ddc"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0784313725490196,
          0.4235294117647059,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2980392156862745,
          0.5568627450980392,
          1
        ],
        "alpha": 1,
        "hex": "#4c8eff"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4745098039215686,
          0.6745098039215687,
          1
        ],
        "alpha": 1,
        "hex": "#79acff"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6470588235294118,
          0.7843137254901961,
          1
        ],
        "alpha": 1,
        "hex": "#a5c8ff"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8235294117647058,
          0.8941176470588236,
          1
        ],
        "alpha": 1,
        "hex": "#d2e4ff"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.996078431372549,
          0.8431372549019608,
          0.8392156862745098
        ],
        "alpha": 1,
        "hex": "#fed7d6"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9764705882352941,
          0.6862745098039216,
          0.6823529411764706
        ],
        "alpha": 1,
        "hex": "#f9afae"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9450980392156862,
          0.5254901960784314,
          0.5294117647058824
        ],
        "alpha": 1,
        "hex": "#f18687"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8980392156862745,
          0.34901960784313724,
          0.3803921568627451
        ],
        "alpha": 1,
        "hex": "#e55961"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8431372549019608,
          0.08235294117647059,
          0.22745098039215686
        ],
        "alpha": 1,
        "hex": "#d7153a"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7490196078431373,
          0.058823529411764705,
          0.20392156862745098
        ],
        "alpha": 1,
        "hex": "#bf0f34"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6549019607843137,
          0.0392156862745098,
          0.17647058823529413
        ],
        "alpha": 1,
        "hex": "#a70a2d"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5607843137254902,
          0.0196078431372549,
          0.15294117647058825
        ],
        "alpha": 1,
        "hex": "#8f0527"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4745098039215686,
          0.00784313725490196,
          0.12549019607843137
        ],
        "alpha": 1,
        "hex": "#790220"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.38823529411764707,
          0,
          0.09803921568627451
        ],
        "alpha": 1,
        "hex": "#630019"
      }
    }
  },
  "blue-orange": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0,
          0.14901960784313725,
          0.39215686274509803
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.00392156862745098,
          0.2,
          0.5019607843137255
        ],
        "alpha": 1,
        "hex": "#013380"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.011764705882352941,
          0.2549019607843137,
          0.6196078431372549
        ],
        "alpha": 1,
        "hex": "#03419e"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.027450980392156862,
          0.30980392156862746,
          0.7411764705882353
        ],
        "alpha": 1,
        "hex": "#074fbd"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.050980392156862744,
          0.36470588235294116,
          0.8627450980392157
        ],
        "alpha": 1,
        "hex": "#0d5ddc"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.0784313725490196,
          0.4235294117647059,
          0.9921568627450981
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.2980392156862745,
          0.5568627450980392,
          1
        ],
        "alpha": 1,
        "hex": "#4c8eff"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4745098039215686,
          0.6745098039215687,
          1
        ],
        "alpha": 1,
        "hex": "#79acff"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6470588235294118,
          0.7843137254901961,
          1
        ],
        "alpha": 1,
        "hex": "#a5c8ff"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8235294117647058,
          0.8941176470588236,
          1
        ],
        "alpha": 1,
        "hex": "#d2e4ff"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.8862745098039215,
          0.8392156862745098
        ],
        "alpha": 1,
        "hex": "#ffe2d6"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.7686274509803922,
          0.6784313725490196
        ],
        "alpha": 1,
        "hex": "#ffc4ad"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.996078431372549,
          0.6509803921568628,
          0.5137254901960784
        ],
        "alpha": 1,
        "hex": "#fea683"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.5254901960784314,
          0.3411764705882353
        ],
        "alpha": 1,
        "hex": "#fa8657"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9529411764705882,
          0.38823529411764707,
          0.10588235294117647
        ],
        "alpha": 1,
        "hex": "#f3631b"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8784313725490196,
          0.3333333333333333,
          0.08627450980392157
        ],
        "alpha": 1,
        "hex": "#e05516"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8,
          0.27450980392156865,
          0.06666666666666667
        ],
        "alpha": 1,
        "hex": "#cc4611"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7254901960784313,
          0.2196078431372549,
          0.043137254901960784
        ],
        "alpha": 1,
        "hex": "#b9380b"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6549019607843137,
          0.16470588235294117,
          0.0196078431372549
        ],
        "alpha": 1,
        "hex": "#a72a05"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5803921568627451,
          0.10588235294117647,
          0
        ],
        "alpha": 1,
        "hex": "#941b00"
      }
    }
  },
  "purple-yellow": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.26666666666666666,
          0.06666666666666667,
          0.4392156862745098
        ],
        "alpha": 1,
        "hex": "#441170"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.3176470588235294,
          0.11764705882352941,
          0.5333333333333333
        ],
        "alpha": 1,
        "hex": "#511e88"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.36470588235294116,
          0.16862745098039217,
          0.6313725490196078
        ],
        "alpha": 1,
        "hex": "#5d2ba1"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.41568627450980394,
          0.2235294117647059,
          0.7333333333333333
        ],
        "alpha": 1,
        "hex": "#6a39bb"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4588235294117647,
          0.27450980392156865,
          0.8392156862745098
        ],
        "alpha": 1,
        "hex": "#7546d6"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5019607843137255,
          0.3333333333333333,
          0.9450980392156862
        ],
        "alpha": 1,
        "hex": "#8055f1"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5882352941176471,
          0.4823529411764706,
          0.9686274509803922
        ],
        "alpha": 1,
        "hex": "#967bf7"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6823529411764706,
          0.6196078431372549,
          0.984313725490196
        ],
        "alpha": 1,
        "hex": "#ae9efb"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7803921568627451,
          0.7490196078431373,
          0.996078431372549
        ],
        "alpha": 1,
        "hex": "#c7bffe"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8901960784313725,
          0.8745098039215686,
          1
        ],
        "alpha": 1,
        "hex": "#e3dfff"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.9411764705882353,
          0.8549019607843137
        ],
        "alpha": 1,
        "hex": "#fff0da"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          1,
          0.8784313725490196,
          0.7058823529411765
        ],
        "alpha": 1,
        "hex": "#ffe0b4"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.996078431372549,
          0.8156862745098039,
          0.5450980392156862
        ],
        "alpha": 1,
        "hex": "#fed08b"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9882352941176471,
          0.7529411764705882,
          0.36470588235294116
        ],
        "alpha": 1,
        "hex": "#fcc05d"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9803921568627451,
          0.6862745098039216,
          0.0196078431372549
        ],
        "alpha": 1,
        "hex": "#faaf05"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8588235294117647,
          0.6,
          0.011764705882352941
        ],
        "alpha": 1,
        "hex": "#db9903"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7411764705882353,
          0.5176470588235295,
          0.00784313725490196
        ],
        "alpha": 1,
        "hex": "#bd8402"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6274509803921569,
          0.43529411764705883,
          0.00392156862745098
        ],
        "alpha": 1,
        "hex": "#a06f01"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5176470588235295,
          0.3568627450980392,
          0
        ],
        "alpha": 1,
        "hex": "#845b00"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4117647058823529,
          0.2823529411764706,
          0
        ],
        "alpha": 1,
        "hex": "#694800"
      }
    }
  },
  "fuchsia-teal": {
    "50": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.396078431372549,
          0,
          0.30196078431372547
        ],
        "alpha": 1,
        "hex": "#65004d"
      }
    },
    "100": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.4823529411764706,
          0.00784313725490196,
          0.37254901960784315
        ],
        "alpha": 1,
        "hex": "#7b025f"
      }
    },
    "150": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5725490196078431,
          0.01568627450980392,
          0.4470588235294118
        ],
        "alpha": 1,
        "hex": "#920472"
      }
    },
    "200": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6627450980392157,
          0.03137254901960784,
          0.5215686274509804
        ],
        "alpha": 1,
        "hex": "#a90885"
      }
    },
    "250": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.7568627450980392,
          0.050980392156862744,
          0.6
        ],
        "alpha": 1,
        "hex": "#c10d99"
      }
    },
    "300": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8509803921568627,
          0.07058823529411765,
          0.6823529411764706
        ],
        "alpha": 1,
        "hex": "#d912ae"
      }
    },
    "350": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9019607843137255,
          0.3568627450980392,
          0.7490196078431373
        ],
        "alpha": 1,
        "hex": "#e65bbf"
      }
    },
    "400": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9411764705882353,
          0.5333333333333333,
          0.8117647058823529
        ],
        "alpha": 1,
        "hex": "#f088cf"
      }
    },
    "450": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9725490196078431,
          0.6941176470588235,
          0.8745098039215686
        ],
        "alpha": 1,
        "hex": "#f8b1df"
      }
    },
    "500": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.9921568627450981,
          0.8470588235294118,
          0.9372549019607843
        ],
        "alpha": 1,
        "hex": "#fdd8ef"
      }
    },
    "550": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.8392156862745098,
          0.8980392156862745,
          0.9098039215686274
        ],
        "alpha": 1,
        "hex": "#d6e5e8"
      }
    },
    "600": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.6823529411764706,
          0.796078431372549,
          0.8196078431372549
        ],
        "alpha": 1,
        "hex": "#aecbd1"
      }
    },
    "650": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.5254901960784314,
          0.6980392156862745,
          0.7294117647058823
        ],
        "alpha": 1,
        "hex": "#86b2ba"
      }
    },
    "700": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.36470588235294116,
          0.6,
          0.6431372549019608
        ],
        "alpha": 1,
        "hex": "#5d99a4"
      }
    },
    "750": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.1803921568627451,
          0.5019607843137255,
          0.5568627450980392
        ],
        "alpha": 1,
        "hex": "#2e808e"
      }
    },
    "800": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.15294117647058825,
          0.4470588235294118,
          0.4980392156862745
        ],
        "alpha": 1,
        "hex": "#27727f"
      }
    },
    "850": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.12549019607843137,
          0.396078431372549,
          0.44313725490196076
        ],
        "alpha": 1,
        "hex": "#206571"
      }
    },
    "900": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.09803921568627451,
          0.34509803921568627,
          0.3843137254901961
        ],
        "alpha": 1,
        "hex": "#195862"
      }
    },
    "950": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.07058823529411765,
          0.29411764705882354,
          0.32941176470588235
        ],
        "alpha": 1,
        "hex": "#124b54"
      }
    },
    "1000": {
      "$type": "color",
      "$value": {
        "colorSpace": "srgb",
        "components": [
          0.043137254901960784,
          0.24705882352941178,
          0.2784313725490196
        ],
        "alpha": 1,
        "hex": "#0b3f47"
      }
    }
  }
}
